var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// import PotentialWell from "../../assets/PotentialWellRelief.svg"
import PotentialWell from "../../assets/potential-well.svg";
import { utilities } from "../utilities/utilities";
export var potentialWell = function (args) {
    var potentialWell = {
        render: function () {
            // const container = document.createElement("div");
            // container.innerHTML = PotentialWell; // insert SVG markup
            // const svgElement = container.querySelector("svg");
            // console.log(container);
            // console.log(svgElement);
            // console.log(PotentialWell);
            // if (svgElement) {
            //     svgElement.style.width = "50px";
            //     svgElement.style.height = "50px";
            // };
            return utilities.html(templateObject_1 || (templateObject_1 = __makeTemplateObject(["<div class=\"flex-shrink-0\" style=\"height:50px; width:50px\">", "</div>"], ["<div class=\"flex-shrink-0\" style=\"height:50px; width:50px\">", "</div>"])), PotentialWell);
            // return `<svg width="50" height="50" xmlns="http://www.w3.org/2000/svg">${svgImage}</svg>`
            // return svgElement!;
            // return utilities.html`<img src=${PotentialWell} />`;
        }
    };
    return potentialWell;
};
var templateObject_1;
